import React from 'react';
import styles from "./index.module.scss";
import classNames from "classnames";
import { Col, Row } from "antd";

import { ReactComponent as HpLogo2 } from './images/fill-29.svg';

let cx = classNames.bind(styles);

const TooGood = (props) => (
    <div className={styles.tooGood}>
        <div className={styles.tooGoodHeading}>
            <HpLogo2 width={68} height={68}/>
            When we save you save
        </div>
        <Row type="flex" justify="center">
            <Col md={22} lg={18} xl={14} className={styles.tooGoodSubHeading}>
                High capacity cartridges, less packaging, less shipping, and cartridge recycling allow HP to pass savings on to you.
            </Col>
        </Row>
    </div>
);

export default TooGood;
